// extracted by mini-css-extract-plugin
module.exports = {"cardBody":"ShipperShipmentDetailsSection_cardBody__1iOGH"};